import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { DelegateConsumer } from '../../../../../DelegateContext'
import Alert from '@material-ui/lab/Alert'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteDelegate = ({ viewDeleteDelegateDialog, openDeleteDelegateDialog, handleDeleteDelegateDialog }) => {
  const classes = useStyles()

  return (
    <DelegateConsumer>
      {({
          delegateData, deleteDelegateLoading, handleDeleteDelegate,
          delegateDataFailure, delegateDataFailureMessage, delegateDataSuccess
        }) => (
        <>
          {!!viewDeleteDelegateDialog &&
          <Dialog
            keepMounted
            fullWidth
            maxWidth={'sm'}
            open={openDeleteDelegateDialog}
            classes={{ paper: classes.NewOrderDialogPaper }}
            TransitionComponent={Transition}
            onClose={handleDeleteDelegateDialog}
            aria-labelledby="BasicInfoDialog"
            aria-describedby="BasicInfoDialog"
          >
            <IconButton
              edge={false}
              className={classes.NewOrderDialogClose}
              color="inherit"
              aria-label="close dialog"
              onClick={handleDeleteDelegateDialog}
            >
              <CloseIcon/>
            </IconButton>
            <DialogContent className={classes.NewOrderDialogContent}>
              <Box px={4} pt={4} pb={1}>
                {!!delegateDataFailure && !!delegateDataFailureMessage &&
                <Alert severity="error">{delegateDataFailureMessage}</Alert>
                }

                {!!delegateDataSuccess &&
                <Alert severity="success">
                  <FormattedMessage
                    id='Delegate.Delete.FormSuccessAlert' values={{ name: delegateData.name }}/>
                </Alert>
                }
                <div className={classes.DeleteOrderWrapper}>
                  {!!deleteDelegateLoading && <FormLoader loading={true}/>}
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Delegate.DeleteMessage' values={{ title: delegateData.name }}/></p>
                </div>
              </Box>
            </DialogContent>
            <DialogActions className={classes.NewOrderDialogFooter}>
              <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                      onClick={() => {
                        handleDeleteDelegate(handleDeleteDelegateDialog)
                      }}>
                <FormattedMessage id='Delegate.Action.Delete'/>
              </Button>
              <Button onClick={handleDeleteDelegateDialog} color="primary">
                <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
              </Button>
            </DialogActions>
          </Dialog>
          }
        </>
      )}
    </DelegateConsumer>
  )
}

export default DeleteDelegate
